import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "../Form";
import { companySelector, userSelector } from "../../redux/selectors";
import { companyQuestions } from "../../utils/constants";
import { setCompany } from "../../redux/actions/company";

const Company: FC<any> = (props) => {
  const { validateForm = false } = props;
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { company } = useSelector(companySelector);
  const { user } = useSelector(userSelector);

  const handleChange = (formData: any, isValid: boolean) => {
    dispatch(
      setCompany({
        ...company,
        formData: { ...company.formData, ...formData, userId: user.id },
        isConfigured: isValid,
      })
    );
  };

  useEffect(() => {
    if (!company.isConfigured && validateForm) {
      setError("You need to select atleast one preference from each section");
    } else {
      setError("");
    }
  }, [company.isConfigured, validateForm]);

  return (
    <>
      <Form
        id="company"
        questions={companyQuestions}
        handleChange={handleChange}
        formData={company.formData}
      />
      <p className="form-error-message">{error}</p>
    </>
  );
};

export default Company;
